/* src/app/pages/inmuebles/inmuebles.component.css */
.row {
  margin: 35px 0px;
}
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100px;
}
.spinner-container img {
  width: 100px;
  height: 100px;
}
.inmuebles-content {
  width: 1332px;
  margin: 0 auto;
  padding: 0;
}
.inmuebles-titulo {
  margin-bottom: 30px;
  text-align: left;
  color: #323E48;
  font-family: "Gotham Medium";
  font-size: 20px;
  line-height: 23px;
}
.empty-container {
  width: auto;
  max-height: fit-content;
  max-width: 627px;
  max-height: 247px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}
.empty-image-container {
  width: 130px;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.empty-image-container img {
  width: 130px;
  height: 130px;
}
.empty-text {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  margin-top: 25px;
  text-align: center;
}
.empty-title {
  font-size: 18px;
  line-height: 25px;
  font-family: "Gotham Medium";
  color: #5B6670;
}
.empty-subtitle {
  margin-top: 10px;
  font-size: 15px;
  line-height: 25px;
  color: #5B6670;
  font-family: "Gotham Book";
}
.filas-inmuebles {
  display: flex;
  flex-direction: column;
  gap: 107px;
}
.fila-inmuebles {
  display: flex;
  justify-content: center;
  column-gap: 44px;
  flex-wrap: wrap;
  row-gap: 44px;
}
.inmueble-card {
  display: flex;
  width: 300px;
  height: 407px;
  flex-direction: column;
  align-items: stretch;
  flex-shrink: 0;
  overflow: hidden;
}
.card-img-top {
  width: 300px;
  height: 150px;
  object-fit: cover;
  display: block;
}
.card-body {
  padding: 10px 20px 20px 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.inmueble-desc {
  font-family: "Gotham Medium";
  font-size: 13px;
  color: #5B6670;
  display: block;
  text-align: left;
  margin: 0px;
  line-height: 18px;
  height: 36px;
  overflow: hidden;
}
.inmueble-price {
  font-family: "Gotham Medium";
  font-size: 18px;
  line-height: 23px;
  color: #323E48;
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;
}
.inmueble-datos {
  margin: 0px;
  padding: 0px;
}
.inmueble-datos label {
  font-family: "Gotham Book";
  font-size: 15px;
  color: #5B6670;
  display: block;
  line-height: 20px;
}
.btn-detalle {
  margin-top: 10px;
  padding: 10px 0px;
  display: flex;
  color: #EB0029;
  font-size: 13px;
  cursor: pointer;
  font-family: "Gotham Medium";
  line-height: 16px;
}
.paginador-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 40px;
}
.paginador-container {
  display: flex;
  align-items: center;
  height: 36px;
  gap: 30px;
  font-family: "Gotham Medium";
  color: #5B6670;
  font-size: 13px;
  line-height: 18px;
}
.paginador-select {
  display: flex;
  gap: 30px;
}
@media (max-width: 400px) {
  .paginador-select {
    gap: 5px;
  }
}
.text-selectFilas {
  display: flex;
  align-items: center;
  word-break: break-word;
}
.select-filas {
  width: 81px;
  height: 32px;
  background-color: #F4F7F8;
  border: none;
  border-radius: 4px;
  padding: 7px 12px 7px 23px;
  font-family: "Gotham Medium";
  font-size: 13px;
  line-height: 18px;
  color: #5B6670;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg width='12' height='7' viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L6 6L11 1' stroke='%235B6670' stroke-width='2'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 15px center;
  background-size: 12px;
}
.select-filas:focus {
  outline: none;
  box-shadow: none;
}
.paginador-botones {
  display: flex;
}
.paginador-botones button {
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.paginador-botones button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.paginador-botones img {
  width: 100%;
  height: 100%;
}
@media (max-width: 1100px) {
  .inmuebles-titulo {
    padding: 0 54px;
  }
}
@media (max-width: 473.5px) {
  .inmuebles-titulo {
    padding: 0 16px;
  }
  .text-selectFilas {
    padding: 0 16px;
  }
}
/*# sourceMappingURL=/banorte/__host/inmuebles/Inmuebles/inmuebles.component.css.map */
